const whyitmattersdata = [{
"id": 0,
"copy": "Feel depressed or suicidal"
},
{
"id": 1,
"copy": "Misuse prescription drugs"
},
{
"id": 2,
"copy": "Use marijuana and other drugs"
},
{
"id": 3,
"copy": "Have poor work performance"
},
{
"id": 4,
"copy": "Have an adolescent pregnancy"
},
{
"id": 5,
"copy": "Be at risk for intimate partner violence"
}];
        
export default whyitmattersdata;


// WEBPACK FOOTER //
// ./src/data/whyitmatterscard.js